import { render, staticRenderFns } from "./SettingPrevious.vue?vue&type=template&id=c48213a6&scoped=true&"
import script from "./SettingPrevious.vue?vue&type=script&lang=js&"
export * from "./SettingPrevious.vue?vue&type=script&lang=js&"
import style0 from "./SettingPrevious.vue?vue&type=style&index=0&id=c48213a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48213a6",
  null
  
)

export default component.exports